import React from 'react';
import {
  IconBulb,
  IconChecklist,
  IconBook,
  IconRocket,
  IconCheck,
} from '@tabler/icons-react';

const STEPS = [
  { label: 'Idealização', icon: IconBulb },
  { label: 'Planejamento', icon: IconChecklist },
  { label: 'Conhecimento', icon: IconBook },
  { label: 'Criação', icon: IconRocket },
];

const WizardStepIndicator = ({ currentStep, skipKnowledge }) => {
  return (
    <div className="awc-stepper" role="navigation" aria-label="Progresso do assistente">
      {STEPS.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isCompleted = currentStep > stepNumber;
        const isSkipped = skipKnowledge && stepNumber === 3;
        const StepIcon = step.icon;

        let circleModifier = 'pending';
        let labelModifier = '';
        if (isSkipped && !isCompleted && !isActive) {
          circleModifier = 'skipped';
          labelModifier = 'skipped';
        } else if (isActive) {
          circleModifier = 'active';
          labelModifier = 'active';
        } else if (isCompleted) {
          circleModifier = 'completed';
          labelModifier = 'completed';
        }

        return (
          <React.Fragment key={stepNumber}>
            {index > 0 && (
              <div className={`awc-stepper__connector${isCompleted ? ' awc-stepper__connector--completed' : ''}`} />
            )}
            <div
              className="awc-stepper__step"
              aria-current={isActive ? 'step' : undefined}
            >
              <div className={`awc-stepper__circle awc-stepper__circle--${circleModifier}`}>
                {isCompleted ? <IconCheck size={18} /> : <StepIcon size={18} />}
              </div>
              <span className={`awc-stepper__label${labelModifier ? ` awc-stepper__label--${labelModifier}` : ''}`}>
                {step.label}
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default WizardStepIndicator;
